import React, { Component } from 'react';
import { Card, message } from 'antd';
import { connect } from 'react-redux';
import { BackBtn } from '@comm/BackBtn';
import { queryBusinessInfo } from '@api/common/business';
import CardBase from './AddressBase';
import TablePayable from './TablePayable';
import PayableStatic from './PayableStatic';
import TableCarry from '../../bill/TableCarry';
import TableCheck from '../../bill/TableCheck';

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {}

  componentDidMount() {
    this.businessInfo();
  }

  businessInfo = () => {
    queryBusinessInfo({
      businessUuid: this.props.params.uuid,
    }).then(res => {
      if (res.statusCode !== 200) {
        message.error(res.message);
      }
    });
  };

  render() {
    const { dataInfo } = this.props;
    return (
      <div>
        <div className="mb16">
          <BackBtn />
        </div>
        <CardBase {...this.props} />
        <Card title="付款约定-账单列表" className="mb16">
          <PayableStatic data={dataInfo} />
          <TablePayable data={dataInfo} />
        </Card>
        <Card title="匹配流水" className="mb16">
          <TableCheck dataSource={dataInfo.incomes} noOp />
        </Card>
        <Card title="结转列表" className="mb16">
          <TableCarry
            dataSource={{
              turns: dataInfo.turns || [],
              oldTurns: dataInfo.oldTurns || [],
            }}
          />
        </Card>
        {/** <Card title="合同审核" className="mb16" /> */}
      </div>
    );
  }
}

export default connect(state => ({ organization: state.organization }))(BaseForm);



// WEBPACK FOOTER //
// ./src/components/incubator/contract/detail/AddressPayable.js